import { render, staticRenderFns } from "./BarHorizontal.vue?vue&type=template&id=8e47846c&scoped=true&"
import script from "./BarHorizontal.vue?vue&type=script&lang=ts&"
export * from "./BarHorizontal.vue?vue&type=script&lang=ts&"
import style0 from "./BarHorizontal.vue?vue&type=style&index=0&id=8e47846c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e47846c",
  null
  
)

export default component.exports